import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { CancelOrder } from "services/V2_APIs/orders.service";
import ErrorAlert from "components/Alerts/error";
import SuccessAlert from "components/Alerts/succes";
import { CancelOrderByDoctor } from "services/V2_APIs/consultationOrders.service";

const CancelDoctorOrder = ({
  activeOrder,
  getOrdersList,
  getOrderById,
  Status,
}) => {
  const [success_msg, setSuccessMsg] = useState(false);
  const [error_msg, setErrorMsg] = useState(false);
  const [modal, setModal] = useState(false);
  const [reason, setReason] = useState("");

  let getPendingStatus = Status;
  console.log(getPendingStatus, "status");
  const toggle = () => setModal(!modal);

  const handleCancelOrder = () => {
    if (!reason) return;

    let body = { user: activeOrder?.fullName, reason: reason };

    CancelOrderByDoctor(activeOrder?._id, body)
      .then(res => {
        if (res?.data) {
          setSuccessMsg(true);
          setModal(false);
        } else {
          setErrorMsg(true);
        }
      })
      .catch(err => {
        setErrorMsg(true);
      });
  };

  const leaveToList = () => {
    setSuccessMsg(false);
    setErrorMsg(false);
    getOrdersList();
    getOrderById(activeOrder);
  };

  const stayHere = () => {
    setSuccessMsg(false);
    setErrorMsg(false);
    getOrdersList();
    getOrderById(activeOrder);
  };
  const isEditable =
    getPendingStatus === "Pending" || getPendingStatus === "Confirmed";
  return (
    <>
      <button
        className={`btn btn-sm ${
          isEditable ? "btn-primary-red" : "btn-secondary"
        }`}
        onClick={() => {
          if (isEditable) {
            setModal(true);
          }
        }}
        disabled={
          !(getPendingStatus === "Pending" || getPendingStatus === "Confirmed")
        }
      >
        Cancel Order
      </button>

      {/* Reactstrap Modal */}
      <Modal isOpen={modal} toggle={toggle} size="sm" centered>
        <ModalHeader toggle={toggle}>Select Cancellation Reason</ModalHeader>
        <ModalBody>
          <select
            className="form-control"
            value={reason}
            onChange={e => setReason(e.target.value)}
          >
            <option value="">Select Reason</option>
            <option value="Cancel">Cancel</option>
            {/* <option value="Time Constraint">Time Constraint</option> */}
          </select>
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={handleCancelOrder} disabled={!reason}>
            Confirm Cancel
          </Button>
          <Button color="light" onClick={toggle}>
            Close
          </Button>
        </ModalFooter>
      </Modal>

      {success_msg && (
        <SuccessAlert
          msg={`Order (#${activeOrder?.orderId}) is cancelled successfully`}
          leaveToList={leaveToList}
          stayHere={stayHere}
        />
      )}
      {error_msg && (
        <ErrorAlert
          msg={"Error occurred"}
          leaveToList={leaveToList}
          stayHere={stayHere}
        />
      )}
    </>
  );
};

export default CancelDoctorOrder;
